export const CONTACT_EMAIL = "contact@example.com";

export const SOCIAL_LINKS = {
  facebook: "#",
  instagram: "#",
  linkedin: "#",
  github: "#",
} as const;
